import {GestionCategorieDto, IGestionCatalogueWebServiceClient} from "@resources/resources";
import {ArianeElement, ArianeStore, ModalService} from "@digicerba/common";
import {ActivatedRoute} from "@angular/router";
import {AsiTable, AsiTableData} from "@asi-ngtools/lib";
import {Component, ViewChild} from "@angular/core";
import * as lodash from "lodash";

@Component({
  selector: 'admin-categorie-component',
  templateUrl: './admin.categories.component.html',
  host: {'class': 'page'}
})
export class AdminCategorieComponent {

  @ViewChild('cmCategorieDataTable') categorieTable: AsiTable<GestionCategorieDto>;
  asiTableData: AsiTableData<GestionCategorieDto> = new AsiTableData<GestionCategorieDto>();

  constructor(private arianeStore: ArianeStore, private activatedRoute: ActivatedRoute, private modalService: ModalService, private gestionCatalogueWebServiceClient: IGestionCatalogueWebServiceClient) {
    let arianeElements: Array<ArianeElement>;
    arianeElements = [
      {
        libelle: "ARIANNE.module",
        route: "/"
      },
      {
        libelle: "ARIANNE.ADMINISTRATION.administration",
        route: "/administration"
      },
      {
        libelle: "ARIANNE.ADMINISTRATION.categories",
        route: "/administration/categories"
      }
    ];

    this.arianeStore.updateElements(arianeElements);
  }

  ngOnInit() {
    this.asiTableData.results = this.activatedRoute.snapshot.data['categories'];
  }

  ngAfterContentInit() {
    this.categorieTable.updateData(this.asiTableData);
  }

  openModal(id: number) {
    this.modalService.openConfirmDialog("MODAL.ADMIN.SUPPRESSION_CATEGORIE.title", "MODAL.ADMIN.SUPPRESSION_CATEGORIE.message",
      "MODAL.ADMIN.SUPPRESSION_CATEGORIE.confirm", "MODAL.ADMIN.SUPPRESSION_CATEGORIE.cancel").onDialogClose().subscribe(() => {
      this.gestionCatalogueWebServiceClient.deleteCategorie(id).subscribe(response => {
        lodash.remove(this.asiTableData.results, function (o) {
          return o.id == id;
        });
        this.categorieTable.updateData(this.asiTableData);
      });
    });
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/pages/administration/categories/admin.categories.component.ts